import EventBus from "./event-bus";
import {errorHandler} from "./common";

const axios = require('axios');

export function getComMetas(type) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'mall/metas/' + type, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getComMeta(id) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'mall/meta/' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function deleteComMeta(id) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.delete(process.env.ROOT_API + 'mall/meta/' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateComMeta(meta) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.post(process.env.ROOT_API + 'mall/meta', JSON.stringify(meta), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateComMetas(metas) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.post(process.env.ROOT_API + 'mall/metas', JSON.stringify(metas), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getNewComMeta(type) {
  let item = {
    id:0,
    title:'',
    metaType:type,
    mainImage:'',
    description:'',
    shortDescription:'',
  }
  return item;
}
export function getComProducts(query) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'mall/products?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getComProduct(id) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'mall/product/' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}


export function updateComProduct(product) {
  return new Promise(function (resolve, reject) {
    console.log("gupdateComProduct ")
    axios.post(process.env.ROOT_API + 'mall/product', JSON.stringify(product), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function createNewComProduct(pId) {
  let item = {
    id:0,
    productId:pId,
    title:'',
    url:'',
    categoryId:0,
    businessTypeId:0,
    net:0,
    netFloat:0.00,
    vatRate:2000,
    vat:0,
    gross:0,
    active:true,
    mainImage:'',
    images:'',
    description:'',
    tags:[],
    availableFromDate:'',
    unitPrice:0,
    units:1,
    size:'',

  };
  return item;
}

export function preCreateProduct(pId) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'mall/product/precreate/' + pId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function searchProducts(word) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'mall/search/products?word=' + word , {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getKokoroCategories() {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'mall/kokoro/categories', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getKokoroProducts(categoryId) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'mall/kokoro/products?categoryId=' + categoryId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function getComSetting(title) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'mall/commerce/setting?title=' + title, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getComSettings(titles) {
  return new Promise(function (resolve, reject) {

    axios.get(process.env.ROOT_API + 'mall/commerce/settings?titles='+titles, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateComSetting(setting) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'mall/commerce/setting', JSON.stringify(setting), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateComSettings(settings) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'mall/commerce/settings', JSON.stringify(settings), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getComSettingDefaultList() {
  let list = [
    {
      id:0,
      title:'stripe_public_key_live',
      name:'Public Key Live',
      type:0,
      textValue:'',
      originalValue:'',
      intValue:0,
    },
    {
      id:0,
      title:'stripe_secret_key_live',
      name:'Secret Key Live',
      type:0,
      textValue:'',
      originalValue:'',
      intValue:0,
    },
    {
      id:0,
      title:'stripe_redirect_domain_live',
      name:'Site Domain Live',
      type:0,
      textValue:'',
      originalValue:'',
      intValue:0,
    },
    {
      id:0,
      title:'stripe_public_key_dev',
      name:'Public Key Dev',
      type:0,
      textValue:'',
      originalValue:'',
      intValue:0,
    },
    {
      id:0,
      title:'stripe_secret_key_dev',
      name:'Secret Key Dev',
      type:0,
      textValue:'',
      originalValue:'',
      intValue:0,
    },
    {
      id:0,
      title:'stripe_redirect_domain_dev',
      name:'Site Domain Dev',
      type:0,
      textValue:'',
      originalValue:'',
      intValue:0,
    },
  ];

  return list;

}

export function getComOrders(query) {
  return new Promise(function (resolve, reject) {

    axios.get(process.env.ROOT_API + 'mall/commerce/orders?'+query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function acceptOrder(orderId) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'mall/commerce/order/capture?id='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/ecomApi.js